import React from "react";

import {
  FaBookOpen,
  FaChevronRight,
  FaHome,
  FaQuestionCircle,
} from "react-icons/fa";

function getSectionNumber(
  sections,
  currentIndex
) {
  return sections
    .slice(0, currentIndex + 1)
    .filter(
      (section) =>
        section.id !== "intro" &&
        section.id !== "faq"
    ).length;
}

function NavigationIndicator({
  section,
  sections,
  index,
}) {
  if (section.id === "intro") {
    return <FaHome />;
  }

  if (section.id === "faq") {
    return <FaQuestionCircle />;
  }

  return getSectionNumber(
    sections,
    index
  );
}

export default function TutorialSidebar({
  sections = [],
  activeSectionId,
  onSelect,
}) {
  return (
    <aside className="hidden self-stretch lg:block">
      <div className="sticky top-[180px] flex max-h-[calc(100vh-200px)] flex-col overflow-hidden rounded-[26px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div className="shrink-0 border-b border-slate-100 p-5 dark:border-slate-800">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300">
              <FaBookOpen />
            </div>

            <div>
              <h2 className="font-semibold text-slate-900 dark:text-white">
                Sommaire
              </h2>

              <p className="text-xs text-slate-500 dark:text-slate-400">
                Accès rapide
              </p>
            </div>
          </div>
        </div>

        <nav
          className="min-h-0 flex-1 space-y-1 overflow-y-auto p-3"
          aria-label="Sommaire du tutoriel"
        >
          {sections.map(
            (section, index) => {
              const isActive =
                activeSectionId ===
                section.id;

              const isSpecialSection =
                section.id === "intro" ||
                section.id === "faq";

              return (
                <button
                  key={section.id}
                  type="button"
                  onClick={() =>
                    onSelect(
                      section.id
                    )
                  }
                  className={`group flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-left transition ${
                    isActive
                      ? "bg-gradient-to-r from-violet-600 to-indigo-600 text-white shadow-lg shadow-violet-600/20"
                      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white"
                  }`}
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl text-xs font-bold ${
                      isActive
                        ? "bg-white/15 text-white"
                        : isSpecialSection
                          ? "bg-violet-50 text-violet-500 group-hover:bg-white dark:bg-violet-500/10 dark:text-violet-300"
                          : "bg-slate-100 text-slate-500 group-hover:bg-white dark:bg-slate-800 dark:text-slate-400 dark:group-hover:bg-slate-700"
                    }`}
                  >
                    <NavigationIndicator
                      section={
                        section
                      }
                      sections={
                        sections
                      }
                      index={index}
                    />
                  </span>

                  <span className="min-w-0 flex-1 text-sm font-medium leading-5">
                    {section.label}
                  </span>

                  <FaChevronRight
                    className={`shrink-0 text-xs ${
                      isActive
                        ? "text-white/80"
                        : "text-slate-300 dark:text-slate-600"
                    }`}
                  />
                </button>
              );
            }
          )}
        </nav>
      </div>
    </aside>
  );
}